import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontSizes, lineHeights, fontWeights,
}: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  modal: {
    width: 558,
    maxWidth: '90vw',
    [breakpoints.down('sm')]: {
      height: '90vh',
    },
  },
  icon: {
    marginBottom: 24,
    lineHeight: 0,
    '& svg': {
      width: 90,
      height: 90,
      [breakpoints.up('md')]: {
        width: 460,
        height: 160,
      },
    },
  },
  title: {
    margin: '20px 0 24px',
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.xxl,
      lineHeight: lineHeights.xxl,
    },
  },
  description: {
    marginBottom: 16,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  footer:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    justifyContent: 'center',
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
}));
